import { useAuth0 } from "./useAuth0";

// Thin wrapper around useAuth0()'s user.roles, which already correctly
// reads the "cognito:groups" claim (see useAuth0.jsx's buildUserFromClaims).
// This used to independently decode the access token itself and read
// payload["https://api.nephrotrax.com/roles"] — an Auth0 custom-claim
// namespace that Cognito never produces, so roles was always an empty
// array here. That silently hid every role-gated menu item and page link
// in Header.jsx for every user, regardless of their actual role, since
// the Cognito migration.
export const useRole = () => {
  const { user, isLoading } = useAuth0();

  const roles = user?.roles || [];

  const hasRole = (role) => roles.includes(role);
  const isAdmin = () => hasRole("Admin");
  const isProvider = () => hasRole("Provider");
  const isPatient = () => hasRole("Patient");
  const isResearcher = () => hasRole("Researcher");
  const isGuest = () => hasRole("Guest");

  return {
    roles,
    // permissions no longer exists as a separate JWT claim under Cognito —
    // authorization is role-based only now (see NephroTrax's Cognito
    // migration). Kept as an empty array for compatibility with any
    // caller still destructuring it, rather than silently changing the
    // shape this hook returns.
    permissions: [],
    loading: isLoading,
    hasRole,
    hasPermission: () => false,
    isAdmin,
    isProvider,
    isPatient,
    isResearcher,
    isGuest,
  };
};